import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "chips", "primary", "more", "moreCount", "clear"]

  connect() {
    if (!this.hasFormTarget) return
    this.revealInvalid = event => {
      const details = event.target.closest("details")
      if (details) details.open = true
    }
    this.formTarget.addEventListener("invalid", this.revealInvalid, true)
    this.renderAppliedFilters()
  }

  disconnect() {
    if (this.hasFormTarget) this.formTarget.removeEventListener("invalid", this.revealInvalid, true)
  }

  // Snapshot the rendered values. Editing a field must not change the chips
  // or their URLs until that edit has actually been applied, including when
  // Turbo restores a cached page that still contains unsaved form edits.
  renderAppliedFilters() {
    const snapshot = this.formTarget.dataset.listFiltersAppliedValues
    const values = snapshot ? JSON.parse(snapshot) : [...new FormData(this.formTarget)]
    if (!snapshot) this.formTarget.dataset.listFiltersAppliedValues = JSON.stringify(values)
    const appliedValues = new Map(values)
    const url = new URL(this.formTarget.action, window.location.origin)
    for (const name of appliedValues.keys()) url.searchParams.delete(name)
    for (const [name, value] of values) {
      if (value !== "" && typeof value === "string") url.searchParams.append(name, value)
    }
    url.searchParams.delete("page")

    const controls = [...this.formTarget.elements].filter(field => /^filters\[[^\]]+\]$/.test(field.name) && appliedValues.has(field.name) && appliedValues.get(field.name) !== "" && !field.disabled)
    const clearURL = new URL(url)
    for (const name of [...clearURL.searchParams.keys()]) {
      if (name.startsWith("filters[")) clearURL.searchParams.delete(name)
    }
    this.clearTargets.forEach(link => link.href = clearURL.toString())
    if (this.hasMoreCountTarget) {
      const count = controls.filter(field => field.closest(".list-filters-more")).length
      this.moreCountTarget.textContent = count
      this.moreCountTarget.classList.toggle("d-none", count === 0)
      this.moreCountTarget.setAttribute("aria-label", `${count} additional filters applied`)
    }
    if (!this.hasChipsTarget) return

    const chips = controls.map(field => {
      const wrapper = field.closest("[data-list-filter-label]")
      const label = wrapper?.dataset.listFilterLabel || field.labels?.[0]?.textContent.trim() || field.name.replace(/^filters\[|\]$/g, "").replaceAll("_", " ")
      const appliedValue = appliedValues.get(field.name)
      const value = wrapper?.dataset.listFilterDisplay || (field.tagName === "SELECT" ? [...field.options].find(option => option.value === appliedValue)?.textContent : appliedValue)
      const text = `${label}: ${value}`
      const removeURL = new URL(url)
      removeURL.searchParams.delete(field.name)
      const link = document.createElement("a")
      link.href = removeURL.toString()
      link.className = "list-filter-chip"
      link.title = text
      link.setAttribute("aria-label", `Remove ${text}`)
      const caption = document.createElement("span")
      caption.textContent = text
      const icon = document.createElement("i")
      icon.className = "bi bi-x"
      icon.setAttribute("aria-hidden", "true")
      link.append(caption, icon)
      return link
    })
    if (chips.length) {
      const clear = document.createElement("a")
      clear.href = clearURL.toString()
      clear.className = "list-filter-clear"
      clear.textContent = "Clear all"
      chips.push(clear)
    }
    this.chipsTarget.replaceChildren(...chips)
    this.chipsTarget.classList.toggle("d-none", controls.length === 0)
  }
}
